import {
  TreeProps as MantineTreeProps,
  Tree as MantineTree,
} from '@mantine/core';

export type TreeProps = MantineTreeProps;

export const Tree = MantineTree;

Tree.displayName = 'Tree';
